import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import api from "api/axios";

function Invitation() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [invitation, setInvitation] = useState(null);
  const [motDePasse, setMotDePasse] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const verifier = async () => {
      try {
        const res = await api.get(`/invitations/${token}`);
        setInvitation(res.data);
      } catch (err) {
        setError("Ce lien est invalide ou a expiré.");
      } finally {
        setLoading(false);
      }
    };
    verifier();
  }, [token]);

  const handleSubmit = async () => {
    setError("");
    if (motDePasse.length < 6) {
      setError("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }
    if (motDePasse !== confirmation) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post(`/invitations/${token}/activer`, { mot_de_passe: motDePasse });
      setSuccess(true);
      setTimeout(() => navigate("/authentication/sign-in"), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "Erreur serveur.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MDBox
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{ bgcolor: "#f0f2f5" }}
    >
      <Card sx={{ width: 400, p: 3 }}>
        <MDBox textAlign="center" mb={3}>
          <MDTypography variant="h4" fontWeight="bold" sx={{ color: "#1976d2" }}>
            GestFete
          </MDTypography>
          <MDTypography variant="body2" color="text">
            Création de votre compte
          </MDTypography>
        </MDBox>

        {loading && (
          <MDBox display="flex" justifyContent="center" py={3}>
            <CircularProgress />
          </MDBox>
        )}

        {!loading && error && !invitation && (
          <MDBox textAlign="center" py={3}>
            <MDTypography variant="body2" color="error">{error}</MDTypography>
          </MDBox>
        )}

        {!loading && success && (
          <MDBox textAlign="center" py={3}>
            <MDTypography variant="h6" sx={{ color: "#43a047" }}>
              Compte créé avec succès !
            </MDTypography>
            <MDTypography variant="body2" color="text" mt={1}>
              Vous allez être redirigé vers la page de connexion...
            </MDTypography>
          </MDBox>
        )}

        {!loading && invitation && !success && (
          <MDBox display="flex" flexDirection="column" gap={2}>
            <MDBox sx={{ bgcolor: "#e3f2fd", borderRadius: 2, p: 2 }}>
              <MDTypography variant="body2">
                <strong>Nom :</strong> {invitation.nom}
              </MDTypography>
              <MDTypography variant="body2">
                <strong>Email :</strong> {invitation.email}
              </MDTypography>
              <MDTypography variant="body2">
                <strong>Ville :</strong> {invitation.ville}
              </MDTypography>
            </MDBox>

            <TextField
              label="Mot de passe"
              type="password"
              fullWidth
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
            />
            <TextField
              label="Confirmer le mot de passe"
              type="password"
              fullWidth
              value={confirmation}
              onChange={(e) => setConfirmation(e.target.value)}
            />

            {error && (
              <MDTypography variant="caption" color="error">{error}</MDTypography>
            )}

            <MDButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
              disabled={submitting}
            >
              {submitting ? "Création..." : "Créer mon compte"}
            </MDButton>
          </MDBox>
        )}
      </Card>
    </MDBox>
  );
}

export default Invitation;